import { render, staticRenderFns } from "./relation-query-base.vue?vue&type=template&id=3059c426"
import script from "./relation-query-base.vue?vue&type=script&lang=ts"
export * from "./relation-query-base.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports